import { render, staticRenderFns } from "./LargeValuePaymentStepDetailsModal.vue?vue&type=template&id=b04ccb5e&scoped=true"
import script from "./LargeValuePaymentStepDetailsModal.vue?vue&type=script&lang=js"
export * from "./LargeValuePaymentStepDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./LargeValuePaymentStepDetailsModal.vue?vue&type=style&index=0&id=b04ccb5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04ccb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b04ccb5e')) {
      api.createRecord('b04ccb5e', component.options)
    } else {
      api.reload('b04ccb5e', component.options)
    }
    module.hot.accept("./LargeValuePaymentStepDetailsModal.vue?vue&type=template&id=b04ccb5e&scoped=true", function () {
      api.rerender('b04ccb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/Modal/LargeValuePaymentStepDetailsModal.vue"
export default component.exports